
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
  ExamInfo,
  StructExam,
  StructExamUserData
} from "@/lib/model/exam/exam";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import _ from "lodash-es";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import Editor from "@/components/editor/classic-editor.vue";
import ContactModal from "@/components/contact-modal.vue";
import ExamCreateForm, { ExamUpdateForm } from "@/lib/form/exam/ExamCreateForm";
import UploadImg from "@/components/UploadImg.vue";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import dayjs from "dayjs";
import PaperSteps from "@/components/exam/paper-steps.vue";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import vuexStore from "@/store/vuex-store";
import BgCheck, { BgCheckProduct } from "@/lib/model/bgcheck/bgcheck";
import ProductListForm from "@/lib/form/bgcheck/ProductListForm";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

@Component({
  components: {
    Editor,
    ContactModal,
    UploadImg,
    Breadcrumb,
    PaperSteps,
    ModalHeader
  }
})
export default class PaperInfo extends Vue {
  name = "paper-bgcheck";
  isDisabled = false;
  hasPaper = false;
  loading = false;
  isSetting = true; //面试设置面包屑标识
  settingForm: StructExam = new StructExam();
  examCreateForm: ExamCreateForm = new ExamCreateForm();
  examUpdateForm: ExamUpdateForm = new ExamUpdateForm();
  testExamList: TestExamList[] = new Array<TestExamList>();
  structExamUserData: StructExamUserData = new StructExamUserData();
  status = "";
  paperId = "0";
  examGetForm = new ExamGetForm();
  //考卷信息缓存Key
  InfoItemCachePrefiex = "EXAM_I";
  studentInfoForm = new StructParam();
  showEditInfoItem = false;
  editInfoIndex = -1;
  startTime = dayjs(new Date()).format("YYYY-MM-DD 10:00:00");
  endTime = new Date();
  defaultDate = new Date();
  defaultEndDate = new Date();
  paperStepType = "add";
  modalTitle = new ModalTitle();
  paperStepNum = 2;
  placeHolder1 = "例如面试预计所需时间、注意事项等";
  rules = this.structExamUserData.rules();
  studentRules = {
    name: [{ required: true, message: "请输入字段名称", trigger: "blur" }]
  };
  bgFixedFoot = true; //悬浮脚按钮
  sideCol = true; //侧边栏收起
  sideStatus = ""; //侧边栏状态
  finishList = [1]; //已完成步骤index
  selectedProduct = "0";
  productListForm: ProductListForm = new ProductListForm();
  comProductList: BgCheckProduct[] = [];
  showConfirm = false;
  showNoProduct = false;
  routerBackStr = ""; // 回跳地址

  @Watch("settingForm.closeUpdate")
  onSettingFormCloseUpdateChange(to: number) {
    this.isDisabled = this.settingForm.closeUpdate == 1;
    this.hasPaper =
      this.settingForm.closeUpdate == 1 || this.settingForm.closeUpdate == 2;
  }
  @Watch("side") //底部按钮位移动画
  sideChanged(n: boolean) {
    this.sideCol = n;
    this.sideStatus = n ? "in" : "out";
  }
  get side() {
    return vuexStore.sideIsCollapse;
  }

  get getSelectedProductId() {
    return parseInt(this.selectedProduct);
  }

  mounted() {
    this.$forceUpdate();
    this.paperStepNum = Number(this.$route?.query?.step) || this.paperStepNum;
    for (let i = 1; i < this.paperStepNum - 1; i++) {
      //已完成步骤index
      this.finishList.push(i);
    }
    this.sideCol = JSON.parse(localStorage.getItem("isCollapse") || "true");
    //滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.handleScroll();
      });
    });
    this.handleScroll();
    this.endTime = new Date(
      this.defaultDate.setDate(this.defaultDate.getDate() + 1)
    );
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    if (this.$route.query.back && this.$route.query.back == "list") {
      this.routerBackStr = this.$route.query.back;
    }
    if (this.$route.query.paperId) {
      this.status = String(this.$route.query.status) || "edit";
      this.paperId = String(this.$route.query.paperId);
      this.getExamInfo();
      this.bgCheckProductList();
    } else {
      this.status = "add";
    }
  }

  selectBgProduct(afterBuy: number, e: number) {
    if (afterBuy === 1) {
      this.selectedProduct = String(e);
    }
  }

  bgCheckProductList() {
    this.productListForm.companyId = parseInt(Auth.companyId);
    BgCheck.BgcheckProductList(this.productListForm).then(res => {
      if (res.data.list.length) {
        this.comProductList = res.data.list;
      }
    });
    console.log("comProductList: ", this.comProductList);
  }

  getExamInfo() {
    if (parseInt(this.paperId) > 0) {
      this.examGetForm.examId = parseInt(this.paperId);
      this.examGetForm.companyId = parseInt(Auth.companyId);
      ExamList.examGet(this.examGetForm).then(res => {
        this.settingForm = this.initPaper(res);
        this.startTime = res.beginTime;
        this.endTime = res.endTime;
        this.selectedProduct = res.bgCheckProductId;
      });
    }
  }

  initPaper(e: StructExam) {
    if (e.testExamId > 0) {
      e.testExam = 1;
    } else {
      e.testExam = 2;
    }
    if (e.noEnding === 1) {
      //长期有效
      e.endDate = "";
      e.endTime = "";
      e.endTiming = "";
      e.startDate = "";
      e.beginTime = "";
      e.startTiming = "";
    } else {
      e.startDate = e.beginTime.slice(0, 10);
      e.startTiming = e.beginTime.slice(11, 16);
      e.endDate = e.endTime.slice(0, 10);
      e.endTiming = e.endTime.slice(11, 16);
    }
    return e;
  }

  cancel() {
    if (this.routerBackStr) {
      this.$router.push(`/exam/paper?companyId=${parseInt(Auth.companyId)}`);
    } else {
      this.$router.push(`/paper-info?paperId=${this.paperId}&status=edit`);
    }
  }

  showConfirmDialog() {
    const productId = parseInt(this.selectedProduct);
    if (productId > 0) {
      this.showConfirm = true;
    } else {
      // 如果创建时未选择产品，不需要二次确认框
      if (this.routerBackStr) {
        this.showNoProduct = true;
      } else {
        this.$router.push(`/paper-edit?paperId=${this.paperId}&step=3`);
      }
    }
  }

  close() {
    this.showConfirm = false;
    this.showNoProduct = false;
  }

  submitBgCheck() {
    this.settingForm.bgCheckProductId = Number(this.selectedProduct);
    const handleRes = this.handleParams(this.settingForm);
    if (handleRes) {
      this.examUpdateForm.assign(handleRes);
      this.examUpdateForm.paramList = this.settingForm.paramList;
      ExamList.examUpdate(this.examUpdateForm)
        .then(res => {
          if (res.code === 0) {
            if (this.routerBackStr) {
              this.$router.push(
                `/exam/paper?companyId=${parseInt(Auth.companyId)}`
              );
            } else {
              this.$router.push(`/paper-edit?paperId=${this.paperId}&step=3`);
            }
          } else {
            this.$message.error("更新失败");
          }
        })
        .catch((catRes: any) => {
          console.log("catch err: ", catRes);
        });
    }
  }

  handleParams(settingForm: StructExam) {
    const form = _.cloneDeep(settingForm);
    if (form.noEnding === 2) {
      if (form.startDate && form.startTiming) {
        form.beginTime =
          form.startDate + " " + form.startTiming.slice(0, 5) + ":00";
      } else {
        this.$message.error("请选择开始时间");
        return false;
      }
      if (form.endDate && form.endTiming) {
        form.endTime = form.endDate + " " + form.endTiming.slice(0, 5) + ":00";
      } else {
        this.$message.error("请选择截止时间");
        return false;
      }
    } else if (form.noEnding === 1) {
      //长期有效
      form.endDate = "2999-12-31";
      form.endTime = "2999-12-31 00:00:00";
      form.endTiming = "00:00";

      form.startDate = "2020-12-11";
      form.beginTime = "2020-12-11 00:00:00";
      form.startTiming = "00:00";
    }
    if (form.endTime < form.beginTime) {
      this.$message.error("面试有效期设置有误");
      return false;
    }
    if (form.testExam === 2) {
      form.testExamId = 0;
    } else if (!form.testExamId) {
      this.$message.error("模拟练习已开启，请选择一道题目");
      return false;
    }
    if (form.useAutoAudit === 1) {
      if (form.autoAuditRefuseScore > form.autoAuditPassScore) {
        this.$message.error(
          "自动评估：自动拒绝的分数必须小于或等于自动通过的分数"
        );
        return false;
      }
    }
    return form;
  }

  getSelectedProductName() {
    const productId = parseInt(this.selectedProduct);
    return this.getProductName(productId);
  }

  // 背调产品转换 ID->名字
  getProductName(productId: number) {
    switch (productId) {
      case 1:
        return "身份基础版";
      case 2:
        return "安全风险版";
      case 3:
        return "金融风险版";
      case 4:
        return "全面核验版";
      default:
        return "";
    }
  }

  getProductDesc(productId: number) {
    switch (productId) {
      case 1:
        return "基础版本，适合仅需要确定候选人身份的真实性";
      case 2:
        return "进阶版本，适合关注候选人是否有安全方面的风险";
      case 3:
        return "进阶版本，适合关注候选人是否有金融方面的风险";
      case 4:
        return "高阶版本，适合关注候选人是否有安全和金融方面的风险";
      default:
        return "";
    }
  }

  //判断某个原生DOM元素是否不在屏幕可见区内
  isElementNotInViewport(el: HTMLElement) {
    const rect = el?.getBoundingClientRect();
    return (
      rect?.top >=
        (window.innerHeight || document.documentElement.clientHeight) ||
      rect?.bottom <= 0
    );
  }
  // 滑动到底 固定底部
  handleScroll() {
    if (this.isElementNotInViewport(this.$refs.bgfoot as HTMLElement)) {
      this.bgFixedFoot = true;
    } else {
      this.bgFixedFoot = false;
    }
  }
}
